import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import routes from '../../../../../../components/Routes/routingMap';
import constants from '../../../../constants';
import CertificateType01InfoView from './CertificateType01InfoView';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const CertificateType01InfoViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();
  const {
    procedure: procedureSelectedInfo,
    selectedProcedureId,
    isLoading
  } = useSelector((state: any) => state.procedureInformation);

  const nameProcedure = React.useMemo(() => {
    switch (selectedProcedureId) {
      case 1027:
        return 'DebtNonDebt';
      case 1018:
        return 'Study';
      case 1019:
        return 'Entry';
      case 1022:
        return 'Belonging';
      case 1023:
        return 'WeightedAveragePeriod';
      case 1024:
        return 'CumulativeWeightedAverage';
      default:
        return '';
    }
  }, [selectedProcedureId]);

  React.useEffect(() => {
    if (nameProcedure.length > 0) {
      GoogleAnalytics.writeLog(
        `portal-procedure-constancy${nameProcedure}`,
        'portal'
      );
    }
  }, [nameProcedure]);

  React.useEffect(() => {
    if (!procedureSelectedInfo && !isLoading) {
      document.title = `UTP + Portal | Universidad Tecnológica del Perú`;
      const selectedCertificate =
        constants.categories.certificates.type1List.find(
          (p) => p.url === params.certificatetype01name
        );
      dispatch(
        procedureActions.getProcedureInformation(
          selectedCertificate?.procedureId
        )
      );
    }
  }, []);

  const selectedCertificate = constants.categories.certificates.type1List.find(
    (p) => p.procedureId === selectedProcedureId
  );

  const handleGoToRegister = (procedure: any) => {
    const cetificateFound = constants.categories.certificates.type1List.find(
      (p) => p.procedureId === procedure
    );
    history.push(
      routes.student.procedures.categories.certificates.certificatetype01.procedureregister.replace(
        ':certificatetype01name',
        cetificateFound?.url || procedure
      )
    );
  };

  const goBack = () => history.goBack();

  React.useEffect(() => {
    if (selectedCertificate)
      document.title = `UTP + Portal | ${selectedCertificate?.name}`;
  }, [procedureSelectedInfo]);

  return (
    <CertificateType01InfoView
      selectedCertificate={selectedCertificate}
      procedureSelectedInfo={procedureSelectedInfo}
      handleClick={handleGoToRegister}
      goBack={goBack}
    />
  );
};

export default CertificateType01InfoViewController;
